/* eslint-disable  @typescript-eslint/no-explicit-any */
import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import CloseIcon from "../../../../../assets/icons/closeIcon.svg";
import "./view-qr-code-popups.scss";

const CreateLeadCapturePopupConfirmation = (props: any) => {
  const {
    isShowConfirmationPopup,
    setIsShowConfirmationPopup,
    QRCodeUrlSelected,
    setQRCodeUrlSelected
  } = props;

  const [imageUrl, setImageUrl] = useState<string>(QRCodeUrlSelected || "");

  return (
    <>
      <Dialog
        open={isShowConfirmationPopup}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={`view-qr-code-popup-confirmation`}
      >
        <DialogTitle id="alert-dialog-title">
          <div className="header-wrapper">
            <div className="image-wrapper">
              <div className="popup-title">View QR Code</div>
              <img
                src={CloseIcon}
                className="close-icon"
                onClick={() => {setIsShowConfirmationPopup(false)
                   setQRCodeUrlSelected("")
                }}
              />
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="view-qr-code-popup-confirmation-description">
            <div className="view-qr-code-popup-confirmation-qr-code">
                <div className="view-qr-code-popup-confirmation-qr-code-box">
                <div className="view-qr-code-popup-confirmation-qr-code-box-img">
                   {imageUrl ? <img
                        src={imageUrl}
                        alt="AFP Horizon Logo"
                    /> : <div>No QR Code Available</div>}
                </div>
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default CreateLeadCapturePopupConfirmation;
